const cachedVariablesJson = require("./cachedVariables.json")

const cachedVariables = cachedVariablesJson || {}

module.exports = cachedVariables
